
import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-gray-800 group-[.toaster]:text-white group-[.toaster]:border-gray-700 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-gray-300",
          actionButton:
            "group-[.toast]:bg-sports-green group-[.toast]:text-black",
          cancelButton:
            "group-[.toast]:bg-gray-600 group-[.toast]:text-white",
          title: "group-[.toast]:text-white group-[.toast]:font-semibold",
          success: "group-[.toast]:bg-green-800 group-[.toast]:border-green-600",
          error: "group-[.toast]:bg-red-800 group-[.toast]:border-red-600",
          warning: "group-[.toast]:bg-yellow-800 group-[.toast]:border-yellow-600",
          info: "group-[.toast]:bg-blue-800 group-[.toast]:border-blue-600",
        },
      }}
      position="top-right"
      {...props}
    />
  )
}

export { Toaster, toast }
